<template>
<div>
  <conference-participants :drawerOpen="drawerOpen"></conference-participants>
  <conference-guest-join></conference-guest-join>
  <v-app-bar
    color="primary"
    max-height="90px"
    app
  >
    <v-btn
      small
      color="primary"
      elevation=0
      v-on:click="closeConference()"
      v-if="!isGuest"
    >
      <v-icon>arrow_back</v-icon>
    </v-btn>
    
    <v-spacer></v-spacer>
    <v-toolbar-title><span style="color:white">{{ conf.name }}</span></v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn icon x-large dark v-if='!drawerOpen' @click='drawerOpen=true'><v-icon>mdi-chevron-double-left</v-icon></v-btn>
  </v-app-bar>
    
  <v-main>
    <v-container fluid>
      
      <v-card>
        <div ref='conferencemedia' style="height:100%"></div>
      </v-card>
      <v-card v-if="showShareScreen && sharing">
          <video vid="video" autoplay></video>
      </v-card>
    </v-container>
  </v-main>
</div>
</template>

<script>
  
  
  import ConferenceCommon from '../mixins/conferencecommon.vue';
  import Common from '../mixins/common.vue';
  import ConferenceParticipants from '../components/conference-participants.vue';
  import ConferenceBottomNav from '../components/conference-bottom-nav.vue';
  import ConferenceJoiningInfo from '../components/conference-joining-info';
  import ConferenceGuestJoin from '../components/conference-guest-join';
  import Vue from 'vue';

  export default {
    components: { 
      'conference-participants': ConferenceParticipants,
      'conference-bottom-nav': ConferenceBottomNav,
      'conference-joining-info': ConferenceJoiningInfo,
      'conference-guest-join': ConferenceGuestJoin,
    },
    mixins: [ConferenceCommon, Common],
    data: function() {
      return {
        test: {},
        monitorTimeoutId: null,
        drawerOpen: true,
        // activeParticipants: 0,
      }
    },
    props: {

    },
    computed: {
      userconfig: {
        get: function() { return this.$store.state.userconfig; },
      },
      session: {
        get() { return this.$store.getters['sip/session'] },
      },
      
    },
    methods: {
      connectWithPin: function(pin) {
        this.$http.get(
          global.apiurl + "/conference/join&" +
            "token=" + encodeURIComponent(this.click2call) +
            "&pin=" + encodeURIComponent(pin)
        );
      },
      showDialInScreen: function() {
        this.showDialIn=true;
        this.showShareScreen=false;
        this.showSettings=false;
      },
      stopScreenSharing: function() {
        this.showDialIn=false;
        this.showShareScreen=true;
        this.showSettings=false;
        this.stopCapture();
      },
      startScreenSharing: function() {
        this.showDialIn=false;
        this.showShareScreen=true;
        this.showSettings=false;
        this.startCapture();
      },
      showSettingsScreen: function() {
        //showDialIn=false;showShareScreen=false;showSettings=true;
        this.showDialIn=false;
        this.showShareScreen=false;
        this.showSettings=true;
      },
      stopCapture: async function() {
        this.sharing = false;
        const videoElem = document.getElementById("video");
        let tracks = videoElem.srcObject.getTracks();
        tracks.forEach(track => track.stop());
        videoElem.srcObject = null;
        videoElem.srcObject = null;
      },
      refreshMedia: async function() {
        console.log('remoteStream', this.session.remoteStream);
        this.$sip.refreshMedia();

        
      },
      startCapture: async function(displayMediaOptions) {
        let self = this;
        this.sharing = true;
        let captureStream = null;

        console.log('starting capture');

        let gdmOptions = {
          video: {
            cursor: "always"
          },
          audio: {
            echoCancellation: true,
            noiseSuppression: true,
            sampleRate: 44100
          }
        };

        try {
          captureStream = await navigator.mediaDevices.getDisplayMedia(gdmOptions);
          const videoElem = document.getElementById("video");
          videoElem.srcObject = captureStream;
          videoElem.addEventListener("suspend", function(evt) {
                                                console.log('suspended');
                                                self.sharing = false;
                                              }, false);
        } catch(err) {
          console.error("Error: " + err);
        }

        return captureStream;
      },
      closeConference: function () {
        this.$store.dispatch('conference/unsubscribeFromCurrentConference');
        this.$router.push('/conferences')
      },
    },
    
    filters: {

    },
    async beforeMount() {
      console.log('params are ' + this.$route.params.confId);
      if (this.$route.params.confId) {
        await this.$store.dispatch('conference/setConferenceByUrlToken', {token: this.$route.params.confId, pin: this.pinPassword});
      } else {
        this.$store.dispatch('conference/getConference');
      }
      if ((!this.$store.state.user) || (this.$store.state.user.user_id == 'guest')) {
          this.$store.dispatch('setStateForGuestConferenceUser', this.$route.params.confId);
      }
      // this.updateParticipantsCount();
    },
    mounted() {
      this.monitorConference(this.conf)
      this.getMediaInputPermissionIfNotSet();
      global.api.userAction('conference_read', this.conf.conference_id, 'webphone');
    },
    beforeDestroy() {
      clearTimeout(this.monitorTimeoutId);
    },
    watch: {
      state: function(newVal,oldVal) {
        console.log('state changed: ' + newVal + ' : ' + oldVal);
        if ((newVal == 'Terminated') && (oldVal == 'Established') && !this.isGuest) {
          this.$store.dispatch('conference/getConferences', null, {root:true});
        }
      },
      session() {
        console.log('conference,  session updated');
        if (this.$refs.conferencemedia) {
          console.log('conference media exists', this.$refs.conferencemedia);
          this.$refs.conferencemedia.innerHTML = '';
          if (!!this.session.mediaElement) {
            console.log('session.mediaElement exists', this.session.mediaElement)
            console.log('session.mediaELement', this.session.mediaElement);
            console.log('conferencemedia', this.$refs.conferencemedia);
            //this.session.mediaElement.width=this.snackWidth;
            if (this.session.mediaElement) {
              this.$refs.conferencemedia.appendChild(this.session.mediaElement);
              
            }
            console.log('conferencemedia', this.$refs.conferencemedia);
          }
        }
      },
    }
  }
</script>

<style scoped>

#video {
  border: 1px solid #999;
  width: 100%;
  height: auto;
}

#minMedia {
  border: 1px solid #999;
  object-fit: fill;
}

.error {
  color: red;
}

.warn {
  color: orange;
}

.info {
  color: darkgreen;
}
#div1{
    background-image:url(https://i.pinimg.com/originals/63/21/bd/6321bdb37eaa860ac7a927f0c901532d.gif);
    background-size:550px;
    height:790px
}

[data-toggle="collapse"] .fa:before {
  content: "\f054";
}

[data-toggle="collapse"].collapsed .fa:before {
  content: "\f054";
}

.right {
  position:absolute;
  right:0
}

span.right {
  position:absolute;;
  right:10px;
}

.list-group-item-info {
  background-color:snow;
  color: black;
  
}

button:active {
  animation: blink 10s 1000 alternate;
}

@keyframes blink {
  from { background-color: orange; }
  to { background-color:tan; }
}

.zerosize {
  width: 0px !important;
  height: 0px !important;
}

</style>

